export type PaymentPlanStatus = 'ACTIVE' | 'COMPLETED' | 'CANCELLED' | 'OVERDUE';

export const getPaymentPlanStatuses = (): PaymentPlanStatus[] => {
  return ['ACTIVE', 'COMPLETED', 'CANCELLED', 'OVERDUE'];
};

export const paymentPlanStatusToTranslationKey = (status: PaymentPlanStatus | undefined): string => {
  switch (status) {
    case 'ACTIVE':
      return 'payment_plan.status.active';
    case 'COMPLETED':
      return 'payment_plan.status.completed';
    case 'CANCELLED':
      return 'payment_plan.status.cancelled';
    case 'OVERDUE':
      return 'payment_plan.status.overdue';
    default:
      return 'payment_plan.status.active';
  }
};

export const paymentPlanStatusToPillColor = (status: PaymentPlanStatus | undefined): string => {
  switch (status) {
    case 'ACTIVE':
      return 'blue';
    case 'COMPLETED':
      return 'green';
    case 'CANCELLED':
      return 'red';
    case 'OVERDUE':
      return 'red';
    default:
      return 'grey';
  }
}; 